import Shimmer from '~/src/atoms/Shimmer';
import tw from 'twin.macro';
import React from 'react';

const SkuLoader = React.forwardRef(({ type, ...rest }, ref) => {
  return (
    <div css={tw`bg-white flex flex-col shadow-6 p-2.5 rounded-xs`} {...rest} ref={ref}>
      <Shimmer css={tw`w-full  xl:w-60 xl:h-60  lg:w-48.5 lg:h-48.5 bg-silverSurfer-200 mb-1 rounded-2xs`} />
      {type !== 'combo' && (
        <div className="flex justify-between mb-1">
          <Shimmer css={tw`w-24 h-5 bg-silverSurfer-200 rounded-2xs`} />
          <Shimmer css={tw`w-12 h-5 bg-silverSurfer-200 rounded-2xs`} />
        </div>
      )}
      <Shimmer css={tw`w-16 h-4.5 bg-silverSurfer-200 rounded-2xs mb-0.5`} />
      <Shimmer css={tw`w-full h-10 bg-silverSurfer-200 mb-0.5 rounded-2xs`} />
      {type !== 'combo' && <Shimmer css={tw`w-20 h-4 bg-silverSurfer-200 rounded-2xs mb-2`} />}
      <Shimmer css={tw`w-full h-7 bg-silverSurfer-200 mb-2 rounded-2xs`} />
      {type !== 'combo' && (
        <div className="flex mb-0.5">
          <Shimmer css={tw`w-20 h-5 mr-1 bg-silverSurfer-200 rounded-2xs`} />
          <Shimmer css={tw`w-10 h-5 bg-silverSurfer-200 rounded-2xs`} />
        </div>
      )}
      <Shimmer css={tw`w-32 h-6 bg-silverSurfer-200 rounded-2xs mb-2.5`} />
      {type !== 'combo' && <Shimmer css={tw`w-full h-7 mb-2.5 bg-silverSurfer-200 rounded-2xs`} />}
      <div className="flex">
        <Shimmer css={tw`w-8 h-8 bg-silverSurfer-200 rounded-2xs mr-2.5`} />
        <Shimmer css={tw`w-full h-8 bg-silverSurfer-200 rounded-2xs`} />
      </div>
      {type === 'combo' && (
        <div className="flex flex-row-reverse">
          <Shimmer css={tw`w-6 mt-0.5 h-6 bg-silverSurfer-200 rounded-2xs`} />
        </div>
      )}
    </div>
  );
});

export default SkuLoader;
